var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#60646C",
    fillRule: "evenodd",
    d: "M10.472 3.529c.26.26.26.682 0 .942L6.943 8l3.529 3.529a.667.667 0 0 1-.943.942l-4-4a.667.667 0 0 1 0-.942l4-4c.26-.26.682-.26.943 0",
    clipRule: "evenodd"
  })));
};
export default SvgChevronLeft;